import { useAuth } from '@beukay/auth-mall';
import { useState } from 'react';
import { history, useSearchParams } from 'umi';
import { useAuthLogin, useCartCount } from '@/hooks';
import { useFormatMessage, useShopCode } from '@/hooks';
import { queryLevelData } from '@/services/api/level';
import { Icon, SelectLang } from '../..';
import SearchMenu from '../../SearchMenu';

const SEARCH = 'TOP_SEARCH';

const Operate = () => {
  const { user } = useAuth();
  const { shopCode } = useShopCode();
  const { locateToLogin } = useAuthLogin();
  const { cartCount } = useCartCount();
  const [searchParams] = useSearchParams();
  const pageType: string = searchParams.get('type') || '';
  const [searchData, setSearchData] = useState([]);
  const [wordsList, setWordsList] = useState([]);
  const [visible, setVisible] = useState(false);
  const { formatMessage } = useFormatMessage();
  const pageId: string = searchParams.get('pageId') || '';
  const { pathname } = window.location;

  const onToggleTopPanel = async (flag: boolean) => {
    if (searchData.length === 0) {
      const res: any = await queryLevelData(
        SEARCH,
        shopCode,
        pageType,
        parseInt(pageId),
      );
      const topSpuItemList = res?.topSpuItemList;
      const topWordList = res?.topWordList;
      setSearchData(topSpuItemList || []);
      setWordsList(topWordList || []);
    }
    setVisible(flag);
  };

  return (
    <div className="absolute top-0 right-[58px] flex items-center h-[50px] z-[9]">
      <div
        onClick={() => onToggleTopPanel(true)}
        className="cursor-pointer w-[100px] h-[18px] pb-[4px] mr-[32px] flex items-center border-b-[1px] border-solid border-b-[#111111]"
      >
        <Icon type="icon-iocn_search" className="text-[12px] text-[#111111]" />
        <div className="text-[12px] text-[#aaaaaa] text-center flex-1">
          {formatMessage({ id: 'pages.home.search', defaultMessage: '搜索' })}
        </div>
      </div>
      {!(
        (pathname.indexOf('info') > -1 && pageType === '1') ||
        (pathname.indexOf('/') > -1 && pageType === '1')
      ) && <SelectLang />}
      <div
        onClick={() => window.open('/cart', '_blank')}
        className="cursor-pointer relative h-[50px] flex items-center pl-[0px] pr-[35px]"
      >
        <Icon
          type="icon-icon_gouwuche"
          className="text-18 ml-[8px] text-[#111111]"
        />
        {cartCount > 0 && (
          <span className="absolute top-[6px] left-[26px] rounded-[5px] px-[3px] text-[#ffffff] text-[10px] font-semibold bg-[#111111] leading-[12px]">
            {cartCount}
          </span>
        )}
      </div>
      {user?.userId ? (
        <Icon
          type="icon-icon_yidenglu"
          className="text-18 text-[#111111] cursor-pointer"
          onClick={() => history.push('/manage/ac/account')}
        />
      ) : (
        <Icon
          type="icon-icon_gerenzhongxin"
          className="text-18 text-[#111111] cursor-pointer"
          onClick={() => locateToLogin()}
        />
      )}
      <SearchMenu
        onClose={(flag) => onToggleTopPanel(flag)}
        visible={visible}
        placement={'top'}
        wordsList={wordsList}
        skuItemList={searchData}
      />
    </div>
  );
};

export default Operate;
